import { get } from "../../../api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const loadFolderSummaryAlpha = (documentId, siteId) =>
  get(`${url}/leasingfolders/${documentId}/${siteId}/alpha/summary`);

const exp = {
  loadFolderSummaryAlpha
};
export default exp;
